import React from 'react';
import {t} from '@lingui/core/macro';

import PaymentsModal from 'features/admin/ui/Payments/PaymentsModal';

import AdminCreateButton from '../AdminList/AdminCreateButton';

const AddPaymentButton: React.FC = () => (
    <AdminCreateButton label={t`Добавить платёж`} Modal={PaymentsModal}/>
);

export default AddPaymentButton;
